const SESSION_ID_STORAGE_KEY = 'lyt.portal.session_id';

/**
 * Create a frontend session identifier.
 *
 * @returns {string}
 */
export const createSessionId = () => {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return `session_${crypto.randomUUID()}`;
    }

    return `session_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
};

/**
 * Return the tab-scoped frontend session identifier, creating one if needed.
 * A refresh in the same tab preserves the identifier.
 *
 * @returns {string}
 */
export const getOrCreateSessionId = () => {
    try {
        if (typeof sessionStorage !== 'undefined') {
            const existing = sessionStorage.getItem(SESSION_ID_STORAGE_KEY);
            if (existing) {
                return existing;
            }

            const created = createSessionId();
            sessionStorage.setItem(SESSION_ID_STORAGE_KEY, created);
            return created;
        }
    } catch {
        // sessionStorage can throw in restricted browser contexts.
    }

    return createSessionId();
};

/**
 * End the current frontend session and return a new identifier.
 *
 * @returns {string}
 */
export const rotateSessionId = () => {
    try {
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.removeItem(SESSION_ID_STORAGE_KEY);
        }
    } catch {
        // Fall through and create an in-memory identifier.
    }

    return getOrCreateSessionId();
};

/**
 * Test helper — clear the persisted frontend session identifier.
 */
export const __resetSessionIdForTests = () => {
    try {
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.removeItem(SESSION_ID_STORAGE_KEY);
        }
    } catch {
        // Ignore unavailable storage in tests.
    }
};
